import Model, { belongsTo, hasMany, attr } from '@ember-data/model';
import { copyable } from 'eflex/decorators';

@copyable
class Trigger extends Model {
  @attr('string', { defaultValue: 'start' }) event;
  @attr('string') hardwareAssignedType;
  @attr('number', { defaultValue: 1 }) hardwareIndex;

  @belongsTo('oee-button', { async: false, inverse: 'triggers', as: 'trigger' }) oeeButton;
  @belongsTo('station', { async: false, inverse: 'triggers', as: 'trigger' }) station;
  @belongsTo('task', { async: false, inverse: 'triggers', as: 'trigger' }) task;

  @belongsTo('hardware', {
    async: false,
    polymorphic: true,
    as: 'trigger',
    inverse: 'triggers',
  }) hardware;

  @hasMany('trigger-config', {
    async: false,
    polymorphic: true,
    as: 'trigger',
    cascadeDelete: true,
    inverse: 'parentTrigger',
  }) triggerConfigs;

  get polymorphic() {
    return true;
  }

  get errorIdentifier() {
    return this.location?.name;
  }

  get location() {
    return this.task ?? this.station ?? this.oeeButton;
  }

  get copyableOptions() {
    return {
      ignoreAttributes: new Set(['station', 'task', 'triggerConfigs', 'oeeButton']),
      copyByReference: new Set(['hardware']),
    };
  }
}

export default Trigger;
